import {useNavigate} from "react-router-dom";
import {useState} from "react";
import axios from "axios";
import Cookies from "universal-cookie/es6";
import {XCircleIcon} from "@heroicons/react/20/solid";
import {useEffect} from "react";
import {useLocation} from "react-router-dom";

export default function ResetPassword() {
    const navigate = useNavigate();
    const cookies = new Cookies()

    //const [remember, setRemember] = useState(false)
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [error, setError] = useState("")
    const [token, setToken] = useState("")

    const search = useLocation().search;
    useEffect(() => {
        setToken(new URLSearchParams(search).get('token'));
    },[])

    function handlePasswordChange(e) {
        setPassword(e.target.value)
    }
    function handleConfirmChange(e) {
        setConfirmPassword(e.target.value)
    }

    function onSubmit(event) {
        event.preventDefault()
        setError(undefined)
        if (password === confirmPassword) {

            let encPassword = btoa(btoa(password))

            axios.post(process.env.REACT_APP_API_URL + "change-password", {"new-password": encPassword, "token" : token})
                .then(function (response) {
                    if (response.data["success"] === true) {
                        console.log("Success")
                        navigate('/')
                    } else {
                        setError(response.data["error"]["description"])
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        } else {
            setError("Password and Confirm Password do not match.")
        }
    }


    return (

        <div className="flex min-h-full w-full flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <img
                    className="mx-auto h-12 w-auto"
                    src={process.env.REACT_APP_URL + "/images/logo-dark.png"}
                    alt="Your Company"
                />
                <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">Reset Password</h2>
            </div>

            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                    <form className="space-y-6" onSubmit={(e) => onSubmit(e)}>
                        { error && <div className="border-l-4 border-red-400 bg-red-50 p-4">
                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <XCircleIcon className="h-5 w-5 text-red-800" aria-hidden="true" />
                                </div>
                                <div className="ml-3">
                                    <p className="text-sm text-red-700">
                                        {error}
                                    </p>
                                </div>
                            </div>
                        </div>}
                        <div>
                            <label htmlFor="newPassword" className="block text-sm font-medium text-gray-700">
                                New Password
                            </label>
                            <div className="mt-1">
                                <input
                                    id="newPassword"
                                    name="newPassword"
                                    type="password"
                                    onChange={handlePasswordChange}
                                    required
                                    className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                />
                            </div>
                        </div>
                        <div>
                            <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">
                                Confirm Password
                            </label>
                            <div className="mt-1">
                                <input
                                    id="confirmPassword"
                                    name="confirmPassword"
                                    type="password"
                                    onChange={handleConfirmChange}
                                    required
                                    className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                />
                            </div>
                        </div>
                        <div>
                            <button
                                type="submit"
                                className="flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            >
                                Confirm
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
